import {
  ChangeDetectionStrategy,
  Component,
  inject,
} from '@angular/core';

import { MerchantEnvironmentMode } from '../merchant-environment-mode';
import { MerchantEnvironmentStore } from '../merchant-environment.store';

@Component({
  selector: 'app-environment-mode-toggle',
  templateUrl: './environment-mode-toggle.component.html',
  styleUrl: './environment-mode-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentModeToggleComponent {
  protected readonly store = inject(MerchantEnvironmentStore);

  protected selectMode(mode: MerchantEnvironmentMode): void {
    this.store.requestModeChange(mode);
  }

  protected toggleSwitch(): void {
    const nextMode: MerchantEnvironmentMode =
      this.store.mode() === 'live' ? 'sandbox' : 'live';
    this.store.requestModeChange(nextMode);
  }
}
